import { useState, useEffect } from 'react';
import { A31, A31Input, A31Output } from 'api/U002';
import { useAuth } from 'hooks/useAuth';
import { FetchError } from 'api/API';

type GetExaminationInfoRequest = Omit<A31Input, 'user_id'>;
export type GetExaminationInfoResponse = A31Output;
export function useGetExaminationInfoHooks(
  param: GetExaminationInfoRequest
): [GetExaminationInfoResponse | null, boolean, Error | null] {
  const auth = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [examinationInfo, setExaminationInfo] = useState<GetExaminationInfoResponse | null>(null);
  const [err, setError] = useState<Error | null>(null);

  const FetchExaminationInfo = async (param: A31Input, cancellation: AbortSignal) => {
    const json = await A31(param, cancellation);
    return json;
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    async function fetch() {
      if (!param.audition_id && param.examination_no != null) return;
      try {
        setLoading(true);
        setError(null);
        const examinationInfo = await FetchExaminationInfo(
          {
            ...param,
            user_id: auth.username,
          },
          signal
        );
        setExaminationInfo(examinationInfo);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [param.audition_id, param.examination_no, auth.username]);

  return [examinationInfo, loading, err];
}
